export default "__VITE_ASSET__DrN$ugR1__"